// Product information extension (admin side): the product's title, description,
// age rating and fields. What it is — its type, and the content type the type
// decides — is the Type tab's (../product-type).
import React from "react"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import InformationTab from "./InformationTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext, useCatalogEditor } from "../shared/catalog-editor"
import AutoTranslateButton from "../shared/AutoTranslateButton"
import { useVendorVisibilityContext } from "../shared/vendor-visibility"
import { setStoreProductUrl } from "aldoo-ra/Store/product-url"
import { buildContentUrl } from "../../../Storefront/utils/contentRoutes"
import { reviewBadge } from "../shared/review-marks"

// the framework's links to a product's store page follow the store's routes (/book/…, /product/…)
setStoreProductUrl(buildContentUrl)

/** Beside the dialog's language picker: fills what is still empty in that language from the default one. */
function AutoTranslateAction() {
  const catalog = useCatalogEditor()
  if (!catalog?.ready || !catalog.editor) return null
  // nothing to fill in the language the product was written in
  if (catalog.editor.language === catalog.editor.defaultLanguage) return null
  return <AutoTranslateButton editor={catalog.editor} />
}

export const StoreProductExtension = {
  // Information carries the name, the id and the description, so the
  // framework's Details tab would only repeat it
  replaces: ["details"],
  id: "product-info",
  label: "Information",
  description: "Title, description, age rating and fields",
  section: {
    component: catalogSection(InformationTab),
    // the SKU and the EAN (the identifiers extension) sit in this tab's own grid
    placesExtendedFields: true,
    label: "Information",
    icon: InformationCircleIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("product-info"),
    order: 100,
    visible: catalogVisible("information"),
  },
  provider: CatalogEditorProvider,
  actions: [AutoTranslateAction],
  // who edits: a merchant's dialog leaves out the tabs only Aldoo decides (Metadata, Store Page)
  visibilityContext: [useCatalogVisibilityContext, useVendorVisibilityContext],
}
